import React from "react";
import { Box, Grid, Typography, Container } from "@mui/material";
import heroImage from "../assets/home.png"; // Replace with your actual image path
import loanRequest from "../assets/loan request.png";
import banner from "../assets/banner.png";
import banner2 from "../assets/banner2.png";
import { useTheme } from "@mui/material/styles";
import { Slide } from "@mui/material";

const HeroSection = () => {
  const theme = useTheme();

  return (
    <Slide direction="up" in={true} timeout={500}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
        }}>
        <Container
          sx={{
            width: "100%",
            maxWidth: "1300px",
            marginTop: { xs: "5px", sm: "5px", lg: "5px" },
          }}>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center" }}>
            {/* Left Column (Text and Banner Image) */}
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#000" }}>
                Get Instant
              </Typography>
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", color: "#000" }}>
                Cash Loan
              </Typography>
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", color: "#000" }}>
                With SAVA
              </Typography>
              <Typography variant="body1" sx={{ color: "#333", mb: 3 }}>
                Unlock your financial freedom with SAVA loan. Request loan, get
                approved, receive money faster today. No hidden fees, Flexible
                loan amounts all on your fingertips with SAVA loan mobile app.
              </Typography>

              {/* Responsive Banner Image */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", lg: "flex-start" },

                  width: "100%",
                  gap: 2,
                }}>
                <Box sx={{}}>
                  {" "}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.sava.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}>
                    <img
                      src={banner}
                      alt="Hero"
                      style={{
                        width: "150px",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </a>
                </Box>

                <Box sx={{}}>
                  <img
                    src={banner2}
                    alt="playstore"
                    style={{
                      height: "auto",
                      width: "150px",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Right Column (Circle Background and Two Images) */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: { xs: "none", sm: "block" } }}>
              <Box
                sx={{
                  borderRadius: "8px", // Optional border radius
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  position: "relative", // Position the circle relative to the parent
                }}>
                {/* First Image (Hero Image) */}
                <img
                  src={heroImage}
                  alt="Hero"
                  style={{
                    width: "35%", // Adjust width as needed
                    height: "auto", // Keeps aspect ratio
                    objectFit: "cover", // Ensures the image covers the space without stretching
                    borderRadius: "8px", // Optional, for rounded corners
                    zIndex: 1,
                  }}
                />

                {/* Second Image (Loan Request) */}
                <img
                  src={loanRequest}
                  alt="Loan Request"
                  style={{
                    width: "35%", // Adjust width as needed
                    height: "auto", // Keeps aspect ratio
                    objectFit: "cover", // Ensures the image covers the space without stretching
                    borderRadius: "8px", // Optional, for rounded corners
                    marginBottom: "150px", // Space between images
                    marginLeft: "15px", // Optional, space from the left of the container
                    zIndex: 1,
                  }}
                />

                {/* Optional Circle Background */}
                {/*           <Box
                sx={{
                  width: "550px", // Circle size (adjust as needed)
                  height: "550px", // Same as width to make it a perfect circle
                  borderRadius: "500px", // Makes it a circle
                  backgroundColor: "#A4D996", // Green background color for the circle
                  position: "absolute", // Position the circle relative to the parent
                  zIndex: 0, // Ensures the circle is behind the images
                  marginLeft: "150px", // Adjust as needed
                  marginBottom: "350px",
                  opacity: 0.5,
                }}
              /> */}
              </Box>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}></Grid>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: { xs: "flex", sm: "none" }, // Show only on xs screens
              width: "100%", // Parent Box width
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}>
            <img
              src={loanRequest}
              alt="Loan Request"
              style={{
                width: "45%", // Adjust width as needed
                height: "auto", // Keeps aspect ratio
                objectFit: "cover", // Ensures the image covers the space without stretching
                borderRadius: "8px", // Optional, for rounded corners
                marginBottom: "70px", // Space between images
                marginLeft: "15px", // Optional, space from the left of the container
                zIndex: 1,
              }}
            />
          </Box>
        </Container>
      </Box>
    </Slide>
  );
};

export default HeroSection;
